import { PreviewsStatus, type PreviewsStatusProps } from '@components/shared/BudgetPreviewsStatus/types'

const WEEK_STATUS_LABELS: Record<PreviewsStatusProps, string> = {
  [PreviewsStatus.NOT_STARTED]: 'Não iniciado',
  [PreviewsStatus.IN_PROGRESS]: 'Em andamento',
  [PreviewsStatus.RELEASED]: 'Liberada',
  [PreviewsStatus.GO_VALIDATION]: 'Em validação GO',
  [PreviewsStatus.RETURNED_GCE]: 'Devolvida GCE',
  [PreviewsStatus.RETURNED_GU]: 'Devolvida GU',
  [PreviewsStatus.CONTROLLER_VALIDATION]: 'Em validação Controller',
  [PreviewsStatus.RETURNED_CONTROLLER]: 'Devolvida Controller',
  [PreviewsStatus.DIRECTOR_VALIDATION]: 'Em validação Diretor',
  [PreviewsStatus.HEAD_FINANCE_VALIDATION]: 'Em validação Financeiro',
  [PreviewsStatus.RETURNED_HEAD_FINANCE]: 'Devolvida Financeiro',
  [PreviewsStatus.VP_APPROVAL]: 'Em validação VP',
  [PreviewsStatus.COMPLETED]: 'Finalizada',
  [PreviewsStatus.RELEASED_SEND]: 'Liberada Envio',
  [PreviewsStatus.GCE_VALIDATION]: 'Em validação GCE',
  [PreviewsStatus.GO_VALIDATION_COMPLETED]: 'Validada GO',
  [PreviewsStatus.DIRECTOR_VALIDATION_COMPLETED]: 'Validada Diretor',
  [PreviewsStatus.COMPLETED_GO_VALIDATION]: 'Validada GO'
}

export const getWeekStatusLabel = (status?: string): string => {
  if (!status) return ''

  return WEEK_STATUS_LABELS[status as PreviewsStatusProps] ?? status
}
